import React, { Component } from "react";

// Externals
import PropTypes from "prop-types";
import classNames from "classnames";

// Material helpers
import { withStyles } from "@material-ui/core";

// Shared components
import { Paper } from "components";

// Component styles
import styles from "./styles";

class IntentCard extends Component {
  onIntentClick = () => {
    const { intent } = this.props;
    this.props.onIntentClick(intent);
  };

  render() {
    const { classes, className, intent } = this.props;

    const rootClassName = classNames(classes.root, className);
    return (
      <div>
        <Paper className={rootClassName} onClick={this.onIntentClick}>
          <span>{intent.name}</span>
        </Paper>
      </div>
    );
  }
}

IntentCard.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  intent: PropTypes.object.isRequired,
  onIntentClick: PropTypes.func.isRequired
};

export default withStyles(styles)(IntentCard);
